export default {
  common: {
    home: 'Home',
    models: 'Models',
    agentBrands: 'Agent Brands',
    dealerBrands: 'Dealer Brands',
    contact: 'Contact Us',
    nisshinbo: 'Nisshinbo',
    feihong: 'FeiHong',
    ketianshi: 'KODENSHI',
    more: 'View More',
    readMore: 'Read More',
    viewDetails: 'View Details',
    submit: 'Submit',
    reset: 'Reset',
    search: 'Search',
    filter: 'Filter',
    category: 'Category',
    region: 'Region',
    company: 'Company',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    message: 'Message',
    subject: 'Subject',
    address: 'Address',
    workingHours: 'Working Hours',
    confirm: 'Confirm',
    menu: 'Menu'
  },
  home: {
    latestNews: 'Latest News',
    aboutUs: 'About Us',
    techFuture: 'Technology Leads the Future',
    innovation: 'Innovation Drives Development',
    introduce:"Kam Zi Technology (HK) Company Ltd is a Hong Kong–based distributor and trading company, serving as the official Hong Kong agent for Nisshinbo Micro Devices, KODENSHI AUK, and FeiHong, while also distributing components from various international and local brands.",
    bizTitle:"The brands we represent cover a wide range of product types, including:",
    biz1:"Analog semiconductors and microwave modules",
    biz2:"Power semiconductors (IGBTs, MOSFETs, discrete transistors)",
    biz3:"Power management ICs (LDOs, DC/DC converters, PMICs)",
    biz4:"Audio processing ICs and volume control ICs",
    biz5:"Optoelectronic devices (photodiodes, phototransistors, photoelectric switches, encoders)",
    biz6:"Sensor modules and analog front ends (AFE)",
    biz7:"Battery management and protection ICs",
    biz8:"Industrial and automotive ASICs/ASSPs",
    introduce2:"With a diverse product portfolio, one-stop procurement services, agile inventory management, reliable logistics, and expert technical support, we rapidly respond to customer needs and ensure stable supply for critical projects."
  },
  searchPage: {
    title: 'Product Search',
    subtitle: 'Enter a model name to search across all product data.',
    browseModels: 'Browse full model list',
    hintBeforeSearch: 'Enter a keyword above, then click Search to see matching models.',
    emptyAfterSearch: 'No matching models found. Try different keywords or browse the full model list.',
    emptySearchWarning: 'Please enter a model name before searching.',
    productModelColumn: 'Product model',
    datasheetDownloadColumn: 'Datasheet download',
    resultCount: '{count} result(s) in total'
  },
  models: {
    clickToDownload: 'Click to download',
    categoryName: 'Category',
    feihongCatTransistor: 'Transistor',
    feihongCatIgbt: 'IGBT',
    feihongCatPlaneMosfet: 'Plane MOSFET',
    feihongCatSuperJunctionMosfet: 'Super junction MOSFET',
    feihongCatTrenchMosfet: 'Trench MOSFET',
    feihongProducts: 'Product List',
    feihongOfficialSite: 'Visit FeiHong website',
    feihongProductListDesc: 'FeiHong product model list. Filter by product model or category only.',
    feihongModelPlaceholder: 'Enter product model',
    ketianshiProducts: 'Product List',
    ketianshiProductListDesc: 'KODENSHI product model list. Filter by product model or category only.',
    ketianshiModelPlaceholder: 'Enter product model',
    kodenshiTopCategory: 'Top category',
    kodenshiCategoryPath: 'Category path',
    kodenshiDetailUrl: 'Detail link',
    kodenshiSegSensor: 'Sensor',
    kodenshiCatDistanceSensor: 'Distance sensor',
    kodenshiCatDualLens: 'Dual lens',
    kodenshiCatSingleLens: 'Single lens',
    kodenshiCatPaperSensor: 'Paper sensor',
    kodenshiCatIndustrialSensor: 'Industrial sensor',
    kodenshiCatLaserDustSensor: 'Laser dust sensor',
    kodenshiCatEncoderModule: 'Encoder module',
    kodenshiCatLightEmitting: 'Light-emitting device',
    kodenshiCatTransmissiveModule: 'Transmissive module',
    kodenshiCatParallelLight: 'Parallel light source',
    kodenshiCatSeparatedType: 'Separate type',
    kodenshiCatPhotodiodeArray: 'Photodiode array',
    kodenshiCatExcitationType: 'Excitation type',
    kodenshiCatIrLed: 'IR LED',
    kodenshiCatPointLightSource: 'Point light source',
    searchPlaceholder: 'Enter model name',
    categoryPlaceholder: 'Select category',
    model: 'Model',
    productName: 'Product Name',
    productVersion: 'Product Version',
    specs: 'Specifications',
    price: 'Reference Price',
    operation: 'Operation',
    datasheet: 'Datasheet Type',
    qualityGrade: 'Quality Grade',
    supplyVoltage: 'Supply Voltage(V)',
    workingTemp: 'Working Temperature(°C)',
    productDetail: 'Product Detail',
    packageType: 'Package Type',
    circuitCount: 'Circuit Count',
    powerType: 'Power Type',
    railToRail: 'Rail-to-Rail',
    plp: 'PLP',
    electricalCharacteristics: 'Electrical Characteristics',
    supplyVoltageRange: 'Supply Voltage Range',
    typicalSupplyCurrent: 'Typical Supply Current',
    maxSupplyCurrent: 'Max Supply Current',
    maxInputOffsetVoltage: 'Max Input Offset Voltage',
    typicalInputBiasCurrent: 'Typical Input Bias Current',
    typicalSlewRate: 'Typical Slew Rate',
    typicalGainBandwidth: 'Typical Gain Bandwidth',
    equivalentInputNoise: 'Equivalent Input Noise',
    outputCurrent: 'Output Current',
    temperatureCharacteristics: 'Temperature Characteristics',
    workingTempRange: 'Working Temperature Range',
    junctionTemp: 'Junction Temperature',
    productFeatures: 'Product Features',
    productSpecification: 'Product Specification',
    disclaimer: 'Specification data is for reference only. Our company is not responsible for the accuracy of the data.',
    allCategories: 'All',
    consumer: 'Consumer',
    industrial: 'Industrial',
    automotive: 'Automotive',
    military: 'Military',
    amplifier: 'Operational Amplifier',
    amplifierDesc: 'High-performance operational amplifiers for precision amplification and signal conditioning applications',
    comparator: 'Comparator',
    comparatorDesc: 'High-speed comparators for signal comparison and threshold detection applications',
    special: 'Special Function Amplifier',
    specialDesc: 'Special function amplifiers including instrumentation amplifiers, differential amplifiers and other specialized products',
    sensorMonitoringAfe: 'AFE for Sensor Monitoring',
    sensorMonitoringAfeDesc: 'Analog Front-End (AFE) products specifically designed for sensor monitoring applications, providing high-precision data acquisition solutions',
    dataConverter: 'Data Converter',
    dataConverterDesc: 'High-performance data converter product series, including voltage-frequency converters and various conversion solutions',
    ldoLinearRegulator: 'LDO Linear Regulator',
    ldoLinearRegulatorDesc: 'Low-dropout linear regulator product series, providing stable voltage output and excellent linear regulation performance',
    dcdcSwitchingRegulator: 'DC/DC Switching Regulator',
    dcdcSwitchingRegulatorDesc: 'High-efficiency DC/DC switching regulator product series, providing excellent power conversion efficiency and stable performance',
    pmics: 'PMICs',
    pmicsDesc: 'Power Management Integrated Circuits product series, providing complete power management solutions for automotive and industrial applications',
    ioLink: 'IO-Link Device Transceiver',
    ioLinkDesc: 'IO-Link device transceiver product series, providing reliable communication solutions for industrial automation applications',
    switchingDriversGate: 'Gate Driver',
    switchingDriversGateDesc: 'Gate driver product series, providing efficient and reliable driving solutions for power switching devices',
    switchingDriversHalf: 'Half-Bridge/Full-Bridge Driver',
    switchingDriversHalfDesc: 'Half-bridge and full-bridge driver product series, providing professional driving solutions for motor control and power conversion applications',
    switchingDriversWboost: 'Full-Bridge Driver with Boost Converter',
    switchingDriversWboostDesc: 'Full-bridge driver with integrated boost converter product series, providing efficient driving solutions for low-voltage applications',
    switchingICs: 'Switch ICs',
    switchingICsDesc: 'Switch ICs product series, providing external power switches, overvoltage protection switches and various switching integrated circuit solutions',
    shuntRegulators: 'Shunt Regulators',
    shuntRegulatorsDesc: 'Shunt Regulators product series, providing high-precision reference voltage regulators and shunt regulator solutions',
    chargePumps: 'Charge Pumps',
    chargePumpsDesc: 'Charge Pumps product series, providing negative voltage converters, voltage doubler converters and other charge pump solutions',
    ssfmOscillator: 'SSFM Oscillator IC',
    ssfmOscillatorDesc: 'SSFM Oscillator IC product series, providing spread spectrum frequency modulation oscillator integrated circuit solutions',
    ledController: 'LED Controller',
    ledControllerDesc: 'LED Controller product series, providing multi-channel LED driver and control solutions',
    voltageDetector: 'Voltage Detector',
    voltageDetectorDesc: 'Voltage Detector product series, providing voltage detection and reset function integrated circuit solutions',
    resetTimer: 'Reset Timer',
    resetTimerDesc: 'Reset Timer product series, providing precise reset timing control and delay function integrated circuit solutions',
    liIonBattery: 'Li-ion Battery Protection',
    liIonBatteryDesc: 'Li-ion Battery Protection product series, providing lithium-ion battery protection and management integrated circuit solutions',
    batteryCharger: 'Battery Charger',
    batteryChargerDesc: 'Battery Charger product series, providing battery charging management and control integrated circuit solutions',
    batteryBackup: 'Battery Back-up ICs',
    batteryBackupDesc: 'Battery Back-up ICs product series, providing battery backup and power management integrated circuit solutions',
    memsTransducer: 'MEMS Transducer',
    memsTransducerDesc: 'MEMS Transducer product series, providing micro-electro-mechanical system sensors and transducers integrated circuit solutions',
    memsMicrophoneAmplifiers: 'MEMS Microphone Amplifiers',
    memsMicrophoneAmplifiersDesc: 'MEMS Microphone Amplifiers product series, providing dedicated pre-amplifiers for MEMS microphones integrated circuit solutions',
    audioAmplifier: 'Audio Amplifier',
    audioAmplifierDesc: 'Audio Amplifier product series, providing high-quality audio amplifier integrated circuit solutions',
    audioSignalProcessor: 'Audio Signal Processor',
    audioSignalProcessorDesc: 'Audio Signal Processor product series, providing audio signal processing and control integrated circuit solutions',
    audioSwitch: 'Audio Switch',
    audioSwitchDesc: 'Audio Switch product series, providing audio signal switching and selection integrated circuit solutions',
    videoIC: 'Video IC',
    videoICDesc: 'Video IC product series, providing video signal processing and control integrated circuit solutions',
    audioVideoMisc: 'Audio & Video misc',
    audioVideoMiscDesc: 'Audio & Video misc product series, providing miscellaneous audio and video integrated circuit solutions',
    rfSwitch: 'RF Switch',
    rfSwitchDesc: 'RF Switch product series, providing radio frequency signal switching and control integrated circuit solutions',
    categoryOthers: 'Others',
    rfSwitchCategorySp3Sp4: 'SP3T / SP4T',
    rfSwitchCategorySp5Sp6: 'SP5T / SP6T',
    lowNoiseAmplifier: 'Low Noise Amplifier',
    lowNoiseAmplifierDesc: 'Low Noise Amplifier product series, providing low noise signal amplification integrated circuit solutions',
    sawFilter: 'SAW Filter',
    sawFilterDesc: 'SAW Filter product series, providing surface acoustic wave filter integrated circuit solutions',
    fmIfDemodulator: 'FM IF Demodulator ICs',
    fmIfDemodulatorDesc: 'FM IF Demodulator ICs product series, providing FM intermediate frequency demodulator integrated circuit solutions',
    amplifierPLL: 'Amplifier-PLL ICs',
    amplifierPLLDesc: 'Amplifier-PLL ICs product series, providing amplifier and phase-locked loop integrated circuit solutions',
    modulationDemodulationMixer: 'Modulation-Demodulation Mixer ICs',
    modulationDemodulationMixerDesc: 'Modulation-Demodulation Mixer ICs product series, providing modulation-demodulation mixer integrated circuit solutions',
    stepperMotorDriver: 'Stepper Motor Driver',
    stepperMotorDriverDesc: 'Stepper Motor Driver product series, providing stepper motor driver integrated circuit solutions',
    threePhaseBLDC: 'Three-Phase BLDC',
    threePhaseBLDCDesc: 'Three-Phase BLDC product series, providing three-phase brushless DC motor pre-driver integrated circuit solutions',
    singlePhaseBLDC: 'Single-Phase / Two-Phase Unipolar BLDC Motor Pre-Drivers',
    singlePhaseBLDCDesc: 'Single-Phase / Two-Phase Unipolar BLDC Motor Pre-Drivers product series, providing single-phase/two-phase unipolar brushless DC motor pre-driver integrated circuit solutions',
    actuatorGateDrivers: 'Actuator / Gate Drivers',
    actuatorGateDriversDesc: 'Actuator / Gate Drivers product series, providing actuator and gate driver integrated circuit solutions',
    realTimeClock: 'Real Time Clock',
    realTimeClockDesc: 'Real Time Clock product series, providing real-time clock integrated circuit solutions',
    quartzCrystalOscillator: 'Quartz Crystal Oscillator ICs',
    quartzCrystalOscillatorDesc: 'Quartz Crystal Oscillator ICs product series, providing quartz crystal oscillator integrated circuit solutions',
    ateAssps: 'ATE assps',
    ateAsspsDesc: 'ATE assps product series, providing automatic test equipment application-specific integrated circuit solutions',
    lcdDrivers: 'LCD Drivers',
    lcdDriversDesc: 'LCD Drivers product series, providing liquid crystal display driver integrated circuit solutions',
    ldDriverICs: 'LD Driver ICs',
    ldDriverICsDesc: 'LD Driver ICs product series, providing laser diode driver integrated circuit solutions',
    analogSwitches: 'Analog Switches',
    analogSwitchesDesc: 'Analog Switches product series, providing analog switch integrated circuit solutions',
    ioPortExpansion: 'IO Port Expansion ICs',
    ioPortExpansionDesc: 'IO Port Expansion ICs product series, providing IO port expansion integrated circuit solutions',
    otherPeripheralICs: 'Other Peripheral ICs',
    otherPeripheralICsDesc: 'Other Peripheral ICs product series, providing other peripheral device integrated circuit solutions',
    allModelsDesc: 'All model products including operational amplifiers, comparators, special function amplifiers and more',
    keyFeatures: 'Key Features',
    func: 'Function Type',
    voltageRange: 'Voltage Range',
    note: 'Note',
    datasheetType: 'Datasheet Type',
    isNew: 'Is New',
    new: 'New',
    features: 'Features',
    inputType: 'Input Type',
    outputType: 'Output Type',
    supplyVoltageMin: 'Min Supply Voltage (V)',
    supplyVoltageMax: 'Max Supply Voltage (V)',
    supplyCurrentTyp: 'Typical Supply Current (mA)',
    supplyCurrentMax: 'Max Supply Current (mA)',
    inputOffsetVoltageTyp: 'Typical Input Offset Voltage (mV)',
    inputOffsetVoltageMax: 'Max Input Offset Voltage (mV)',
    propagationDelay: 'Propagation Delay (ns)',
    tempMin: 'Min Operating Temp (°C)',
    tempMax: 'Max Operating Temp (°C)',
    resolution: 'Resolution',
    speed: 'Speed',
    interface: 'Interface',
    advantages: 'Advantages',
    currentConsumption: 'Current Consumption',
    maxCurrentConsumption: 'Max Current Consumption',
    pinCount: 'Pin Count',
    downloadDatasheet: 'Download Datasheet',
    downloadSpec: 'Download specification',
    converterType: 'Converter Type',
    outputVoltage: 'Output Voltage',
    inputVoltage: 'Input Voltage',
    inputVoltageRange: 'Input Voltage Range',
    dropoutVoltage: 'Dropout Voltage',
    quiescentCurrent: 'Quiescent Current',
    lineRegulation: 'Line Regulation',
    loadRegulation: 'Load Regulation',
    outputNoise: 'Output Noise',
    psrr: 'PSRR',
    enableControl: 'Enable Control',
    thermalShutdown: 'Thermal Shutdown',
    currentLimit: 'Current Limit',
    operatingTemp: 'Operating Temperature',
    applications: 'Applications',
    switchingFrequency: 'Switching Frequency',
    efficiency: 'Efficiency',
    standard: 'Standard',
    grade: 'Grade',
    functionDesc: 'Function Description',
    buckDcdc: 'Buck DC/DC',
    ldoCount: 'LDO Count',
    vdCount: 'VD Count',
    wdtCount: 'WDT Count',
    gpioCount: 'GPIO Count',
    driveCircuit: 'Drive Circuit',
    switchingCurrent: 'Switching Current',
    outputRiseTime: 'Output Rise Time',
    outputFallTime: 'Output Fall Time',
    fault: 'Fault Detection',
    protections: 'Protections',
    architecture: 'Architecture',
    productUrl: 'Product URL',
    visitProductPage: 'Visit Product Page',
    outputPeakCurrent: 'Output Peak Current',
    switchingCurrentBoost: 'Boost Switching Current',
    referenceVoltage: 'Reference Voltage',
    tolerance: 'Tolerance',
    cathodeCurrent: 'Cathode Current',
    dynamicImpedance: 'Dynamic Impedance',
    temperatureCoefficient: 'Temperature Coefficient',
    frequency: 'Frequency',
    frequencyTolerance: 'Frequency Tolerance',
    supplyCurrent: 'Supply Current',
    operatingVoltageRange: 'Operating Voltage Range',
    channelCount: 'Channel Count',
    ledCurrent: 'LED Current',
    brightnessControl: 'Brightness Control',
    pwmSteps: 'PWM Steps',
    detectionVoltage: 'Detection Voltage',
    detectionVoltageAccuracy: 'Detection Voltage Accuracy',
    hysteresis: 'Hysteresis',
    resetTimeout: 'Reset Timeout',
    operatingTemperature: 'Operating Temperature',
    accuracy: 'Accuracy',
    outputDelayTime: 'Output Delay Time',
    outputReleaseTime: 'Output Release Time',
    overchargeVoltage: 'Overcharge Voltage',
    overdischargeVoltage: 'Overdischarge Voltage',
    overcurrentDetection: 'Overcurrent Detection',
    outputFunction: 'Output Function',
    operatingVoltage: 'Operating Voltage',
    constantVoltage: 'Constant Voltage',
    constantCurrent: 'Constant Current',
    linear: 'Linear',
    switching: 'Switching',
    normalOperation: 'Normal Operation',
    backUpMode: 'Back-up Mode',
    lowDropout: 'Low Dropout',
    voltageDetection: 'Voltage Detection',
    dualChannel: 'Dual Channel',
    singleChannel: 'Single Channel',
    biasVoltage: 'Bias Voltage',
    staticCapacitance: 'Static Capacitance',
    chipSize: 'Chip Size',
    audio: 'Audio',
    video: 'Video',
    microphone: 'Microphone',
    transducer: 'Transducer',
    mems: 'MEMS',
    snr: 'SNR',
    maximumOutputVoltage: 'Maximum Output Voltage',
    notes: 'Notes',
    preAmplifier: 'Pre-Amplifier',
    lowPower: 'Low Power',
    amplifierType: 'Amplifier Type',
    control: 'Control',
    channel: 'Channel',
    btl: 'BTL',
    outputPower: 'Output Power',
    voltageGain: 'Voltage Gain',
    functions: 'Functions',
    powerAmplifier: 'Power Amplifier',
    headphoneAmplifier: 'Headphone Amplifier',
    processorType: 'Processor Type',
    volumeRange: 'Volume Range',
    toneControl: 'Tone Control',
    inputSelector: 'Input Selector',
    inputChannel: 'Input Channel',
    outputChannel: 'Output Channel',
    auxInput: 'Aux Input',
    auxOutput: 'Aux Output',
    licenseFeatures: 'License Features',
    electronicVolume: 'Electronic Volume',
    signalProcessor: 'Signal Processor',
    audioProcessor: 'Audio Processor',
    dsp: 'DSP',
    input: 'Input',
    output: 'Output',
    inputOutput: 'Input/Output',
    audioSelector: 'Audio Selector',
    stereo: 'Stereo',
    mono: 'Mono',
    icCategory: 'IC Category',
    gain: 'Gain',
    driverSeventyFiveOhm: '75Ω Driver',
    lpfThOrder: 'LPF Order',
    inputChannels: 'Input Channels',
    outputChannels: 'Output Channels',
    videoAmplifier: 'Video Amplifier',
    videoSwitch: 'Video Switch',
    videoFilter: 'Video Filter',
    ecm: 'ECM',
    thd: 'THD',
    misc: 'Misc',
    rf: 'RF',
    switch: 'Switch',
    highFrequency: 'High Frequency',
    lowLoss: 'Low Loss',
    spdt: 'SPDT',
    sp4t: 'SP4T',
    spst: 'SPST',
    dpdt: 'DPDT',
    noiseFigure: 'Noise Figure',
    iipThree: 'IIP3',
    operatingCurrent: 'Operating Current',
    packageSize: 'Package Size',
    poneDb: 'P1dB',
    frontEndModules: 'Front-End Modules',
    rfAmplifier: 'RF Amplifier',
    wideband: 'Wideband',
    narrowband: 'Narrowband',
    centerFrequency: 'Center Frequency',
    passbandWidth: 'Passband Width',
    gps: 'GPS',
    glonass: 'GLONASS',
    galileo: 'Galileo',
    beidou: 'BeiDou',
    wifi: 'WiFi',
    bluetooth: 'Bluetooth',
    cellular: 'Cellular',
    productFunction: 'Product Function',
    mixerFrequency: 'Mixer Frequency',
    fskComparator: 'FSK Comparator',
    filterAmplifiers: 'Filter Amplifiers',
    quickCharge: 'Quick Charge',
    rssi: 'RSSI',
    otherFeatures: 'Other Features',
    wideBand: 'Wide Band',
    narrowBand: 'Narrow Band',
    highPerformance: 'High Performance',
    referenceFrequency: 'Reference Frequency',
    amplifierSupport: 'Amplifier Support',
    pllSupport: 'PLL Support',
    mixerSupport: 'Mixer Support',
    pll: 'PLL',
    mixer: 'Mixer',
    modulationDemodulation: 'Modulation/Demodulation',
    modulation: 'Modulation',
    demodulation: 'Demodulation',
    fsk: 'FSK',
    waveShaping: 'Wave Shaping',
    driveMode: 'Drive Mode',
    inputMode: 'Input Mode',
    motorCount: 'Motor Count',
    driverCategory: 'Driver Category',
    logicVoltage: 'Logic Voltage',
    absoluteMaximumRating: 'Absolute Maximum Rating',
    outputModeFeature: 'Output Mode Feature',
    currentSelectFeature: 'Current Select Feature',
    excitationModeFeature: 'Excitation Mode Feature',
    vrInputFeature: 'VR Input Feature',
    bipolar: 'Bipolar',
    unipolar: 'Unipolar',
    pwm: 'PWM',
    clk: 'CLK',
    outputDriveMode: 'Output Drive Mode',
    phaseInput: 'Phase Input',
    leadAngle: 'Lead Angle',
    predriverCategory: 'Pre-driver Category',
    squareWave120: '120° Square Wave',
    squareWave180: '180° Square Wave',
    sineWave: 'Sine Wave',
    singlePhase: 'Single-Phase',
    twoPhase: 'Two-Phase',
    gateDriver: 'Gate Driver',
    actuator: 'Actuator',
    interfaceType: 'Interface Type',
    timeKeepingCurrent: 'Time Keeping Current',
    timeKeepingVoltage: 'Time Keeping Voltage',
    timeKeepingVoltageRange: 'Time Keeping Voltage Range',
    alarm: 'Alarm',
    periodicalInterrupt: 'Periodical Interrupt',
    clockOutput: 'Clock Output',
    twoWire: '2-wire',
    threeWire: '3-wire',
    i2c: 'I2C',
    spi: 'SPI',
    oscillationFrequency: 'Oscillation Frequency',
    oscillatorCategory: 'Oscillator Category',
    divider: 'Divider',
    voltageRegulator: 'Voltage Regulator',
    cmos: 'C-MOS',
    lvds: 'LVDS',
    lvpecl: 'LVPECL',
    ttl: 'TTL',
    pinElectronics: 'Pin Electronics',
    driver: 'Driver',
    ate: 'ATE',
    test: 'Test',
    dutyRatio: 'Duty Ratio',
    displaySize: 'Display Size',
    displaySizeSegments: 'Display Size Segments',
    displaySizeCommons: 'Display Size Commons',
    displaySizeLines: 'Display Size Lines',
    displaySizeChannels: 'Display Size Channels',
    operatingVoltageVdd: 'Operating Voltage VDD',
    operatingVoltageVlcd: 'Operating Voltage VLCD',
    ddramBits: 'DDRAM Bits',
    evrSteps: 'EVR Steps',
    voltageBooster: 'Voltage Booster',
    icon: 'Icon',
    lcdCategory: 'LCD Category',
    eightBit: '8-bit',
    fourBit: '4-bit',
    serial: 'Serial',
    parallel: 'Parallel',
    channels: 'Channels',
    ldType: 'LD Type',
    maxOperatingFrequency: 'Max Operating Frequency',
    driveCurrentLed: 'LED Drive Current',
    driveCurrentOperating: 'Operating Drive Current',
    driveCurrentThreshold: 'Threshold Drive Current',
    ledCurrentMinPulseWidth: 'LED Current Min Pulse Width',
    risingFallingTime: 'Rising/Falling Time',
    maxOutputRatePerChannel: 'Max Output Rate Per Channel',
    maxOperatingCurrentLd1: 'Max Operating Current LD1',
    maxOperatingCurrentLd2: 'Max Operating Current LD2',
    maxOperatingCurrentLd3: 'Max Operating Current LD3',
    maxOperatingCurrentLd4: 'Max Operating Current LD4',
    aecQ100: 'AEC-Q100',
    protectionCircuit: 'Protection Circuit',
    ldCategory: 'LD Category',
    ldCommon: 'Common',
    cathode: 'Cathode',
    anode: 'Anode',
    onStateResistance: 'On-State Resistance',
    analogSwitch: 'Analog Switch',
    outputPort: 'Output Port',
    operatingVoltageMin: 'Min Operating Voltage',
    operatingVoltageMax: 'Max Operating Voltage',
    operatingVoltageTyp: 'Typ Operating Voltage',
    min: 'MIN',
    ledDrive: 'LED Drive',
    status: 'Status',
    compliant: 'Compliant',
    peripheral: 'Peripheral',
    // Menu Categories
    audioICs: 'Audio ICs',
    videoICs: 'Video ICs',
    powerManagementICs: 'Power Management ICs',
    batteryManagementICs: 'Battery Management ICs',
    switchingDriverICs: 'Switching Driver ICs',
    signalProcessingICs: 'Signal Processing ICs',
    interfaceControlICs: 'Interface & Control ICs',
    specialFunctionICs: 'Special Function ICs'
  },
  agentBrands: {
    title: 'Agent Brands',
    subtitle: 'We have established long-term stable cooperative relationships with many well-known brands',
    brands: {
      nisshinbo: 'Nisshinbo Micro Devices Inc. is a Japanese semiconductor company formed by the merger of the original Japan Radio Company (JRC) and Ricoh Microelectronics in 2022. Specializing in operational amplifiers (Op-Amps), power management ICs (LDO regulators, DC/DC converters), audio processing ICs, sensor modules and analog front-ends (AFE), battery management ICs, microwave amplifiers, filters, and automotive ASICs/ASSPs.',
      muses: 'The MUSES series is a flagship analog semiconductor product line tailored for high-end audio equipment, covering operational amplifiers, power management ICs, and volume controllers, aiming to perfectly reproduce "authentic sound".',
      auk: 'KODENSHI AUK (Shenyang Zhongguang Electronics Co., Ltd., KODENSHI SY Corp.) belongs to the KODENSHI AUK Group, established in August 1992 in Shenyang Economic and Technological Development Zone. It focuses on R&D, production, and sales of optoelectronic devices, with products covering photodiodes, phototransistors, photoelectric switches, encoders, paper sensors, and optocouplers, providing one-stop services from wafer manufacturing, IC design to packaging testing, module development, and OEM/ODM.',
      feihong: 'Guangzhou FeiHong Semiconductor Technology Co., Ltd. was established in 2002, headquartered in Yuexiu District, Guangzhou. It is a leading domestic IGBT and MOSFET manufacturer, focusing on R&D, production, and sales of high-power field-effect transistors and discrete semiconductor devices, widely used in home appliances, LED lighting, power equipment, chargers, inverters, new energy vehicles, and industrial applications.'
    },
    cooperationTime: 'Cooperation Time',
    mainProducts: 'Main Products',
    marketCoverage: 'Market Coverage',
    cooperationProcess: 'Cooperation Process',
    step1: 'Initial Consultation',
    step1Desc: 'Understanding mutual needs',
    step2: 'Collaboration Assessment',
    step2Desc: 'Discuss cooperation conditions',
    step3: 'Agreement Signing',
    step3Desc: 'Confirming cooperation details',
    step4: 'Formal Cooperation',
    step4Desc: 'Starting business cooperation',
    contactTitle: 'Brand Cooperation Inquiry',
    contactDesc: 'If you are interested in cooperating with us, please fill out the following form and we will contact you as soon as possible',
    cooperationIntention: 'Cooperation Intention',
    submitApplication: 'Submit Application'
  },
  dealerBrands: {
    title: 'Dealer Brands',
    subtitle: 'We provide distribution services for various quality brands',
    advantages: 'Distribution Advantages',
    advantage1: 'Quality Source',
    advantage1Desc: 'Direct cooperation with well-known brands to ensure product quality',
    advantage2: 'Price Advantage',
    advantage2Desc: 'Factory direct supply, favorable prices, large profit margin',
    advantage3: 'Marketing Support',
    advantage3Desc: 'Provide professional marketing solutions and promotion support',
    advantage4: 'After-sales Service',
    advantage4Desc: 'Perfect after-sales service system to solve worries'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'We look forward to establishing contact with you',
    contactInfo: 'Contact Information',
    companyAddress: 'Company Address',
    address: 'Room 07, 10/F, Tower B, New Trade Plaza, 6 On Ping Street, Shek Mun, Shatin, Hong Kong',
    addressZhongshan: 'Room 808, Comprehensive Office Building, Zhongshan Bonded Logistics Center, Sunshine Avenue, Minzhong Town, Zhongshan City',
    contactPhone: 'Contact Phone',
    phone1: '(852)2635 2112',
    contactEmail: 'Email',
    email: 'cs@kamzitech.com',
    workingTime: 'Working Hours',
    weekdays: 'Monday to Friday: 9:00 - 17:30',
    onlineMessage: 'Online Message',
    companyLocation: 'Company Location'
  },
  validation: {
    nameRequired: 'Please enter your name',
    phoneRequired: 'Please enter your phone number',
    emailRequired: 'Please enter your email address',
    emailFormat: 'Please enter a valid email address',
    subjectRequired: 'Please enter a subject',
    messageRequired: 'Please enter your message',
    companyRequired: 'Please enter company name',
    intentionRequired: 'Please enter cooperation intention'
  },
  message: {
    submitSuccess: 'Message submitted successfully, we will contact you soon!',
    submitFailed: 'Submission failed, please try again later',
    fetchNewsFailed: 'Failed to fetch news',
    fetchModelsFailed: 'Failed to fetch models list',
    fileNotFound: 'File not found',
    downloadStarted: 'Download started',
    downloadFailed: 'Download failed'
  },
  footer: {
    aboutUs: 'About Us',
    aboutUsDesc: 'KAM ZI TECHNOLOGY (HK) COMPANY LTD.',
    contactInfo: 'Contact Information',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    followUs: 'Follow Us',
    companyName: 'KAM ZI TECHNOLOGY (HK) COMPANY LTD.',
    allRightsReserved: 'All Rights Reserved',
    whatsappQr: 'WhatsApp QR Code',
    wechatQr: 'WeChat QR Code',
    telegramQr: 'Telegram QR Code',
  }
} 
